import Action from './baseActions';
import {
  ApiParams,
} from '../../models';

// Types
interface INoteflowParams extends ApiParams {
  reload?: boolean;
}

export enum NoteflowActionTypes {
  EXECUTE_NOTEFLOW = 'noteflow/execute',
  EXECUTING_NOTEFLOW = 'noteflow/executing',
  EXECUTED_NOTEFLOW = 'noteflow/executed',
  EXECUTING_NOTEFLOW_FAILED = 'noteflow/executing_failed',
  UNSET_EXECUTE_REQUEST_FLAG = 'noteflow/unset_execute_request_flag',

  CHECK_NOTEFLOW_EXECUTION = 'noteflow/check_execution',
  LOAD_NOTEFLOW_EXECUTION = 'noteflow/load_execution',
  LOADING_NOTEFLOW_EXECUTION = 'noteflow/loading_execution',
  LOADED_NOTEFLOW_EXECUTION = 'noteflow/loaded_execution',
  LOADING_NOTEFLOW_EXECUTION_FAILED = 'noteflow/loading_execution_failed',

  LOAD_NOTEFLOW_TASK_RESULTS = 'noteflow/load_task_results',
  LOADING_NOTEFLOW_TASK_RESULTS = 'noteflow/loading_task_results',
  LOADED_NOTEFLOW_TASK_RESULTS = 'noteflow/loaded_task_results',
  LOADING_NOTEFLOW_TASK_RESULTS_FAILED = 'noteflow/loading_task_results_failed',

  LOAD_NOTEFLOW_EXECUTIONS = 'noteflow/load_executions',
  LOADING_NOTEFLOW_EXECUTIONS = 'noteflow/loading_executions',
  LOADED_NOTEFLOW_EXECUTIONS = 'noteflow/loaded_executions',
  LOADING_NOTEFLOW_EXECUTIONS_FAILED = 'noteflow/loading_executions_failed',

  LOAD_RE_RUNS = 'noteflow/load_re_runs',
  LOADING_RE_RUNS = 'noteflow/loading_re_runs',
  LOADED_RE_RUNS = 'noteflow/loaded_re_runs',
  LOADING_RE_RUNS_FAILED = 'noteflow/loading_re_runs_failed',

  SET_NOTEFLOW_FILTERS = 'noteflow/set_filters',
  UNSET_NOTEFLOW_FILTERS = 'noteflow/unset_filters',

  UNSET_NOTEFLOW_EXECUTIONS = 'noteflow/unset_executions',

  LOAD_NOTEFLOW_EXECUTION_LOGS = 'noteflow/load_execution_logs',
  LOADING_NOTEFLOW_EXECUTION_LOGS = 'noteflow/loading_execution_logs',
  LOADED_NOTEFLOW_EXECUTION_LOGS = 'noteflow/loaded_execution_logs',
  LOADING_NOTEFLOW_EXECUTION_LOGS_FAILED = 'noteflow/loading_execution_logs_failed',

  /*
   * Noteflow Filters actions
   */
  LOAD_SEARCH_REPORT = 'noteflow/load_search_report',
  LOADED_SEARCH_REPORT = 'noteflow/loaded_search_report',
  LOADING_SEARCH_REPORT_FAILED = 'noteflow/loading_search_report_failed',

  LOAD_SEARCH_USER = 'noteflow/load_search_user',
  LOADED_SEARCH_USER = 'noteflow/loaded_search_user',
  LOADING_SEARCH_USER_FAILED = 'noteflow/loading_search_user_failed',

  RESET_SEARCH = 'noteflow/reset_search',
}

// Interfaces

export interface IExecuteNoteflowAction extends Action {
  type: NoteflowActionTypes.EXECUTE_NOTEFLOW;
  payload: string;  // report identifier
}

export interface IExecutingNoteflowAction extends Action {
  type: NoteflowActionTypes.EXECUTING_NOTEFLOW;
}

export interface IExecutedNoteflowAction extends Action {
  type: NoteflowActionTypes.EXECUTED_NOTEFLOW;
  payload: any;
}

export interface IExecutingNoteflowFailedAction extends Action {
  type: NoteflowActionTypes.EXECUTING_NOTEFLOW_FAILED;
}

export interface IUnsetExecuteRequestFlagAction extends Action {
  type: NoteflowActionTypes.UNSET_EXECUTE_REQUEST_FLAG;
}

export interface ICheckNoteflowExecutionAction extends Action {
  type: NoteflowActionTypes.CHECK_NOTEFLOW_EXECUTION;
  payload: {
    uid: string; // noteflowRunUid
    /*
     * source is current page `uid`; check until the same source - this can differ on page change;
     * in case it changed, stop `check execution`
     */
    source: string;
    counter: number; // safety check; check until,
  }
}

export interface ILoadNoteflowExecutionAction extends Action {
  type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTION;
  payload: {
    flowRunId: string;
    detailed: boolean;
  }
}

export interface ILoadingNoteflowExecutionAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION;
}

export interface ILoadedNoteflowExecutionAction extends Action {
  type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTION;
  payload: {
    result: any;
  }
}

export interface ILoadingNoteflowExecutionFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_FAILED;
}

export interface ILoadNoteflowTaskResultsAction extends Action {
  type: NoteflowActionTypes.LOAD_NOTEFLOW_TASK_RESULTS;
  payload: string; // noteflowRunUid
}

export interface ILoadingNoteflowTaskResultsAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_TASK_RESULTS;
}

export interface ILoadedNoteflowTaskResultsAction extends Action {
  type: NoteflowActionTypes.LOADED_NOTEFLOW_TASK_RESULTS;
  payload: any;
}

export interface ILoadingNoteflowTaskResultsFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_TASK_RESULTS_FAILED;
}

export interface ILoadNoteflowExecutionsAction extends Action {
  type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTIONS;
  payload: INoteflowParams;
}

export interface ILoadingNoteflowExecutionsAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTIONS;
}

export interface ILoadedNoteflowExecutionsAction extends Action {
  type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTIONS;
  payload: {
    result: any;
    reload: boolean;
    page_size: number;
  };
}

export interface ILoadingNoteflowExecutionsFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTIONS_FAILED;
}

export interface ILoadReRunsAction extends Action {
  type: NoteflowActionTypes.LOAD_RE_RUNS;
  payload: {
    parentId: string;
    flowRunId?: string;
  }
}

export interface ILoadingReRunsAction extends Action {
  type: NoteflowActionTypes.LOADING_RE_RUNS;
}

export interface ILoadedReRunsAction extends Action {
  type: NoteflowActionTypes.LOADED_RE_RUNS;
  payload: {
    result: any;
  };
}

export interface ILoadingReRunsFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_RE_RUNS_FAILED;
}

export interface ISetNoteflowFiltersAction extends Action {
  type: NoteflowActionTypes.SET_NOTEFLOW_FILTERS;
  payload: any;
}

export interface IUnsetNoteflowFiltersAction extends Action {
  type: NoteflowActionTypes.UNSET_NOTEFLOW_FILTERS;
}

export interface IUnsetNoteflowExecutionsAction extends Action {
  type: NoteflowActionTypes.UNSET_NOTEFLOW_EXECUTIONS
  payload?: string; // if specified, unset executions for a specific report page or report
}

export interface ILoadNoteflowExecutionLogsAction extends Action {
  type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTION_LOGS;
  payload: string; // noteflow run identifier
}

export interface ILoadingNoteflowExecutionLogsAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_LOGS;
}

export interface ILoadedNoteflowExecutionLogsAction extends Action {
  type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTION_LOGS;
  payload: any;
}

export interface ILoadingNoteflowExecutionLogsFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_LOGS_FAILED;
}

/*
 * Noteflow Filters actions
 */
export interface ILoadSearchReportAction extends Action {
  type: NoteflowActionTypes.LOAD_SEARCH_REPORT;
  payload: string;
}

export interface ILoadedSearchReportAction extends Action {
  type: NoteflowActionTypes.LOADED_SEARCH_REPORT;
  payload: any;
}

export interface ILoadingSearchReportFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_SEARCH_REPORT_FAILED;
}

export interface ILoadSearchUserAction extends Action {
  type: NoteflowActionTypes.LOAD_SEARCH_USER;
  payload: string;
}

export interface ILoadedSearchUserAction extends Action {
  type: NoteflowActionTypes.LOADED_SEARCH_USER;
  payload: any;
}

export interface ILoadingSearchUserFailedAction extends Action {
  type: NoteflowActionTypes.LOADING_SEARCH_USER_FAILED;
}

export interface IResetSearchAction extends Action {
  type: NoteflowActionTypes.RESET_SEARCH;
  payload?: string;
}

// Functions

export function executeNoteflow(reportId: string): IExecuteNoteflowAction {
  return {
    type: NoteflowActionTypes.EXECUTE_NOTEFLOW,
    payload: reportId
  }
}

export function executingNoteflow(): IExecutingNoteflowAction {
  return {
    type: NoteflowActionTypes.EXECUTING_NOTEFLOW
  }
}

export function executedNoteflow(response: any): IExecutedNoteflowAction {
  return {
    type: NoteflowActionTypes.EXECUTED_NOTEFLOW,
    payload: response
  }
}

export function executingNoteflowFailed(): IExecutingNoteflowFailedAction {
  return {
    type: NoteflowActionTypes.EXECUTING_NOTEFLOW_FAILED
  }
}

export function unsetExecuteRequestFlag(): IUnsetExecuteRequestFlagAction {
  return {
    type: NoteflowActionTypes.UNSET_EXECUTE_REQUEST_FLAG
  }
}

export function checkNoteflowExecution(
  uid: string,
  source: string,
  counter: number,
): ICheckNoteflowExecutionAction {
  return {
    type: NoteflowActionTypes.CHECK_NOTEFLOW_EXECUTION,
    payload: {
      uid, // noteflow_run_uid
      source, // page uid
      counter,
    }
  }
}

export function loadNoteflowExecution(flowRunId: string, detailed: boolean = false): ILoadNoteflowExecutionAction {
  /*
   * `detailed` - loads all info; if `false`, excludes logs
   */
  return {
    type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTION,
    payload: {
      flowRunId,
      detailed,
    }
  }
}

export function loadingNoteflowExecution(): ILoadingNoteflowExecutionAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION,
  }
}

export function loadedNoteflowExecution(
  result: any,
): ILoadedNoteflowExecutionAction {
  return {
    type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTION,
    payload: {
      result,
    }
  }
}

export function loadingNoteflowExecutionFailed(): ILoadingNoteflowExecutionFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_FAILED,
  }
}

export function loadNoteflowTaskResults(uid: string): ILoadNoteflowTaskResultsAction {
  return {
    type: NoteflowActionTypes.LOAD_NOTEFLOW_TASK_RESULTS,
    payload: uid
  }
}

export function loadingNoteflowTaskResults(): ILoadingNoteflowTaskResultsAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_TASK_RESULTS,
  }
}

export function loadedNoteflowTaskResults(result: any): ILoadedNoteflowTaskResultsAction {
  return {
    type: NoteflowActionTypes.LOADED_NOTEFLOW_TASK_RESULTS,
    payload: result
  }
}

export function loadingNoteflowTaskResultsFailed(): ILoadingNoteflowTaskResultsFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_TASK_RESULTS_FAILED,
  }
}

export function loadNoteflowExecutions(
  properties: INoteflowParams,
  reload: boolean = false,
): ILoadNoteflowExecutionsAction {
  return {
    type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTIONS,
    payload: {
      ...properties || {},
      reload,
    },
  }
}

export function loadingNoteflowExecutions(): ILoadingNoteflowExecutionsAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTIONS,
  }
}

export function loadedNoteflowExecutions(
  result: any,
  reload: boolean = false,
  page_size: number = 0,
): ILoadedNoteflowExecutionsAction {
  return {
    type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTIONS,
    payload: {
      result,
      reload,
      page_size,
    }
  }
}

export function loadingNoteflowExecutionsFailed(): ILoadingNoteflowExecutionsFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTIONS_FAILED,
  }
}

export function loadReRuns(parentId: string, flowRunId?: string): ILoadReRunsAction {
  /*
   * Specific flow for by parentId
   */
  return {
    type: NoteflowActionTypes.LOAD_RE_RUNS,
    payload: {
      parentId,
      flowRunId,
    },
  }
}

export function loadingReRuns(): ILoadingReRunsAction {
  return {
    type: NoteflowActionTypes.LOADING_RE_RUNS,
  }
}

export function loadedReRuns(result: any): ILoadedReRunsAction {
  return {
    type: NoteflowActionTypes.LOADED_RE_RUNS,
    payload: {
      result,
    }
  }
}

export function loadingReRunsFailed(): ILoadingReRunsFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_RE_RUNS_FAILED,
  }
}

export function setNoteflowFilters(filters: any): ISetNoteflowFiltersAction {
  return {
    type: NoteflowActionTypes.SET_NOTEFLOW_FILTERS,
    payload: filters
  }
}

export function unsetNoteflowFilters(): IUnsetNoteflowFiltersAction {
  return {
    type: NoteflowActionTypes.UNSET_NOTEFLOW_FILTERS
  }
}

export function unsetNoteflowExecutions(sourceUid?: string): IUnsetNoteflowExecutionsAction {
  return {
    type: NoteflowActionTypes.UNSET_NOTEFLOW_EXECUTIONS,
    payload: sourceUid,
  }
}

export function loadNoteflowExecutionLogs(flowRunId: string): ILoadNoteflowExecutionLogsAction {
  return {
    type: NoteflowActionTypes.LOAD_NOTEFLOW_EXECUTION_LOGS,
    payload: flowRunId
  }
}

export function loadingNoteflowExecutionLogs(): ILoadingNoteflowExecutionLogsAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_LOGS,
  }
}

export function loadedNoteflowExecutionLogs(result: any): ILoadedNoteflowExecutionLogsAction {
  return {
    type: NoteflowActionTypes.LOADED_NOTEFLOW_EXECUTION_LOGS,
    payload: result
  }
}

export function loadingNoteflowExecutionLogsFailed(): ILoadingNoteflowExecutionLogsFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_NOTEFLOW_EXECUTION_LOGS_FAILED,
  }
}

/*
 * Noteflow Filter Actions
 */
export function loadSearchReport(text: string): ILoadSearchReportAction {
  return {
    type: NoteflowActionTypes.LOAD_SEARCH_REPORT,
    payload: text
  }
}

export function loadedSearchReport(result: any): ILoadedSearchReportAction {
  return {
    type: NoteflowActionTypes.LOADED_SEARCH_REPORT,
    payload: result,
  }
}

export function loadingSearchReportFailed(): ILoadingSearchReportFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_SEARCH_REPORT_FAILED,
  }
}

export function loadSearchUser(text: string): ILoadSearchUserAction {
  return {
    type: NoteflowActionTypes.LOAD_SEARCH_USER,
    payload: text
  }
}

export function loadedSearchUser(result: any): ILoadedSearchUserAction {
  return {
    type: NoteflowActionTypes.LOADED_SEARCH_USER,
    payload: result,
  }
}

export function loadingSearchUserFailed(): ILoadingSearchUserFailedAction {
  return {
    type: NoteflowActionTypes.LOADING_SEARCH_USER_FAILED,
  }
}

export function resetSearch(type?: string): IResetSearchAction {
  return {
    type: NoteflowActionTypes.RESET_SEARCH,
    payload: type
  }
}

export type NoteflowActions =
  | IExecuteNoteflowAction
  | IExecutingNoteflowAction
  | IExecutedNoteflowAction
  | IExecutingNoteflowFailedAction
  | IUnsetExecuteRequestFlagAction
  | ICheckNoteflowExecutionAction
  | ILoadNoteflowExecutionAction
  | ILoadingNoteflowExecutionAction
  | ILoadedNoteflowExecutionAction
  | ILoadingNoteflowExecutionFailedAction
  | ILoadNoteflowTaskResultsAction
  | ILoadingNoteflowTaskResultsAction
  | ILoadedNoteflowTaskResultsAction
  | ILoadingNoteflowTaskResultsFailedAction
  | ILoadNoteflowExecutionsAction
  | ILoadingNoteflowExecutionsAction
  | ILoadedNoteflowExecutionsAction
  | ILoadingNoteflowExecutionsFailedAction
  | ILoadReRunsAction
  | ILoadingReRunsAction
  | ILoadedReRunsAction
  | ILoadingReRunsFailedAction
  | ISetNoteflowFiltersAction
  | IUnsetNoteflowFiltersAction
  | IUnsetNoteflowExecutionsAction
  | ILoadNoteflowExecutionLogsAction
  | ILoadingNoteflowExecutionLogsAction
  | ILoadedNoteflowExecutionLogsAction
  | ILoadingNoteflowExecutionLogsFailedAction
  | ILoadSearchReportAction
  | ILoadedSearchReportAction
  | ILoadingSearchReportFailedAction
  | ILoadSearchUserAction
  | ILoadedSearchUserAction
  | ILoadingSearchUserFailedAction
  | IResetSearchAction;
